import React, { useEffect, useState } from "react";
import { BackButton } from "../../components/btn/Buttons";
import PageHeading from "../../components/PageHeading";
import { Input } from "../../components/inputs/Inputs";
import Dropdown from "../../components/inputs/Dropdown";
import Button from "../../components/btn/Button";
import Table from "../../components/table/Table";
import { useSelector } from "react-redux";
import "./trasactionReport.css";
import { downloadExcel, downloadExcel1, exportPDF } from "../../utils/utils";
import moment from "moment";
import { DateValidatorReports } from "../../utils/validation";
import { stock_report_api } from "../../utils/apis";
import NoData from "../../components/NoData";
import { Pagination3 } from "../../components/pagination/pagination";
import { get_stock_report_list } from "./transactionReportSlice";
import store from "../../redux/store";
import { godownHeader, OnlyProductHeader, ProductGodownHeader, TableHeaderProduct } from "../../utils/data";
import { setLoadingMain, setMessAlert, setOpenAlert } from "../../redux/slice/actionSlice";

const StockReport = () => {
  const [addData, setAddData] = useState({});
  const [addDataPre, setAddDataPre] = useState({});
  const [totalCount, setTotalCount] = useState("1");
  const [entries, setEntries] = useState(5);
  const [pageNo, setPageNo] = useState(1);
  const [serchInput, setSerchInput] = useState("");
  const [showData, setShowData] = useState(false);
  const [stock_report_item_list, setStock_report_item_list] = useState([]);
  const [totalData, setTotalData] = useState([]);
  const { stock_report_list } = useSelector((state) => state.transactionReport);
  const { user_id } = useSelector((state) => state.other);

  useEffect(() => {
    store.dispatch(get_stock_report_list());
  }, []);
  const { firm_name } = useSelector((state) => state.profile);
  const fetchData = () => {
    if (showData) {
      get_list(addDataPre);
    }
  };
  // SearchApiHook(fetchData, serchInput?.trim(), prevSearch, [entries, pageNo]);
  useEffect(() => {
    fetchData();
  }, [pageNo, entries]);

  const table_data_3 = (addData, header, type = 1) => {
    const data = [
      ...addData?.map((v, i) =>
        type == 1
          ? [i + 1, ...Object.keys(header).map((val) => v[val])]
          : [...Object.keys(header).map((val) => v[val])]
      ),
    ];
    return data;
  };

  const file_name_header = (addData) => {
    return `${firm_name} - STOCK REPORTS -- FROM DATE : ${moment(
      addData?.from_date
    ).format("DD/MM/YY")} & TO DATE : ${moment(addData?.to_date).format(
      "DD/MM/YY"
    )}   :: ${addData?.action == "godown" ? "GODOWN" : "PRODUCT"} : : ${
      addData?.custProdDetails
    }`;
  };
  const export_pdf = (addData, data, total) => {
    if (addData?.action == "godown") {
      exportPDF({
        table_data: table_data_3(data, godownHeader),
        table_headers: ["S.No.", ...Object.values(godownHeader)],
        fileName: file_name_header(addData),
        tableName: file_name_header(addData),
        table2: false,
      });
    } else if (
      addData?.action == "product" &&
      (addData?.godown_id || !addData?.show_godown)
    ) {
      exportPDF({
        table_data: table_data_3(data, TableHeaderProduct),
        table_headers: ["S.No.", ...Object.values(TableHeaderProduct)],
        fileName: file_name_header(addData),
        tableName: file_name_header(addData),
        table2: true,
        table_headers_2: Object.values(
          !addData?.show_godown ? OnlyProductHeader : ProductGodownHeader
        ),
        table_data_2: table_data_3(
          total,
          !addData?.show_godown ? OnlyProductHeader : ProductGodownHeader,
          0
        ),
      });
    } else if (addData?.action == "product" && !addData?.godown_id) {
      exportPDF({
        table_data: table_data_3(total, OnlyProductHeader, 0),
        table_headers: Object.values(OnlyProductHeader),
        fileName: file_name_header(addData),
        tableName: file_name_header(addData),
      });
    }
  };

  const export_excel = (addData, data, total) => {
    if (addData?.action == "godown") {
      downloadExcel(
        table_data_3(data, godownHeader),
        ["S.No.", ...Object.values(godownHeader)],
        file_name_header(addData)
      );
    } else if (
      addData?.action == "product" &&
      (addData?.godown_id || !addData?.show_godown)
    ) {
      downloadExcel1(
        table_data_3(data, TableHeaderProduct),
        ["S.No.", ...Object.values(TableHeaderProduct)],
        file_name_header(addData),
        table_data_3(
          total,
          !addData?.show_godown ? OnlyProductHeader : ProductGodownHeader,
          0
        ),
        Object.values(
          !addData?.show_godown ? OnlyProductHeader : ProductGodownHeader
        )
      );
    } else if (addData?.action == "product" && !addData?.godown_id) {
      downloadExcel(
        table_data_3(total, OnlyProductHeader,0),
        Object.values(OnlyProductHeader),
        file_name_header(addData)
      );
    }
  };

  const get_list = async (addData, data1 = "") => {
    const data = validate(addData);
    if (data?.length == 0) {
      try {
        store.dispatch(setLoadingMain(true));
        const body = new FormData();
        body.append("action", addData?.action);
        body.append("agencyid", user_id);
        body.append("sdate", addData?.from_date);
        body.append("edate", addData?.to_date);
        body.append("id", addData?.godown_id || "");
        body.append("page", data1?.length > 1 || data1 == "main" ? 1 : pageNo);
        body.append(
          "limit",
          data1?.length > 1 ? (data1 == "main" ? entries : totalCount) : entries
        );
        if (addData?.action == "godown") {
          body.append("godown_id", addData?.product_code || "");
        } else {
          body.append("prod_code", addData?.product_code || "");
          body.append("prod_cat", addData?.product_cat || "");
        }

        const response = await stock_report_api(body);
        if (response.success) {
          if (data1 == "excel") {
            export_excel(
              addData,
              response?.data || response?.productlist,
              response?.total
            );
          } else if (data1 == "pdf") {
            export_pdf(
              addData,
              response?.data || response?.productlist,
              response?.total
            );
          } else {
            setStock_report_item_list(
              addData?.action == "product" &&
                !addData?.godown_id &&
                addData?.show_godown
                ? response?.total
                : response?.data
            );
            setTotalCount(response?.totalcount);
            setTotalData(response?.total);
            setShowData(true);
            setAddDataPre(addData);
          }
        } else if (!response.success) {
          setStock_report_item_list([]);
          setTotalCount(0);
          setTotalData([]);
          setShowData(false);
          setAddDataPre([]);
          store.dispatch(setOpenAlert(true));
          store.dispatch(setMessAlert(response.message));
        }
      } catch (error) {
        console.log(error);
      }finally{
        store.dispatch(setLoadingMain(false));
      }
    } else {
      store.dispatch(setOpenAlert(true));
      store.dispatch(setMessAlert(data));
    }
  };

  const validate = (addData) => {
    const data = [];
    const DateValidatorReportsData = DateValidatorReports(
      moment(addData?.from_date).format("DD/MM/YYYY"),
      moment(addData?.to_date).format("DD/MM/YYYY")
    );
    if (
      !addData?.from_date ||
      (addData?.from_date && addData?.from_date?.length != 10)
    ) {
      data.push("Please Enter From Date");
    } else if (
      !addData?.to_date ||
      (addData?.to_date && addData?.to_date?.length != 10)
    ) {
      data.push("Please Enter TO DATE");
    } else if (DateValidatorReportsData != true) {
      data.push(...DateValidatorReportsData);
    }
    if (!addData?.action || (addData?.action && addData?.action?.length == 0)) {
      data.push("Please Select Party Type");
    } else if (
      !addData?.product_code ||
      (addData?.product_code && addData?.product_code?.length == 0)
    ) {
      data.push("Please Select Either PRODUCT / GODOWN");
    }
    return data;
  };

  return (
    <div className="container">
      <PageHeading title="STOCK REPORT" right={<BackButton />} />

      {/* --- Filters Section --- */}
      <div className="transactionMain">
        {[
          {
            label: "FROM DATE",
            value: addData?.from_date,
            type: "date",
            onChange: (val) =>
              val.length <= 10 && setAddData({ ...addData, from_date: val }),
          },
          {
            label: "TO DATE",
            value: addData?.to_date,
            type: "date",
            onChange: (val) =>
              val.length <= 10 && setAddData({ ...addData, to_date: val }),
          },
        ].map((item, i) => (
          <div key={i} style={{ width: "180px" }}>
            <Input
              label={item.label}
              type={item.type}
              value={item.value}
              onChange={(e) => item.onChange(e.target.value)}
            />
          </div>
        ))}

        {/* Party Type Dropdown */}
        <div style={{ width: "180px" }}>
          <Dropdown
            label="Select Party type"
            value={addData?.action}
            onChange={(e) =>
              setAddData({
                ...addData,
                action: e.target.value,
                product_code: "",
                product_cat: "",
                show_godown: false,
              })
            }
            options={
              <>
                <option value="">SELECT</option>
                <option value="product">PRODUCT WISE</option>
                <option value="godown">GODOWN WISE</option>
              </>
            }
          />
        </div>

        {/* Product/Godown Dropdown */}
        <div style={{ width: "180px" }}>
          <Dropdown
            label="PRODUCT / GODOWN"
            value={addData?.product_code}
            onChange={(e) => {
              const selectedData = (
                addData?.action === "product"
                  ? stock_report_list?.productlist
                  : addData?.action === "godown"
                  ? stock_report_list?.godownlist
                  : []
              )?.find((v) => v?.ID == e.target.value);

              const showGodown = [
                "REGULATOR",
                "COMMERCIAL",
                "DOMESTIC",
              ].includes(selectedData?.CAT_NAME);

              setAddData({
                ...addData,
                product_code: e.target.value,
                show_godown: showGodown,
                godown_id: showGodown ? addData?.godown_id : "",
                product_cat: selectedData?.CAT_TYPE || "",
                custProdDetails:
                  selectedData?.CAT_NAME && selectedData?.CAT_DESC
                    ? `${selectedData.CAT_NAME} - ${selectedData.CAT_DESC}`
                    : selectedData?.UNIT_NAME,
              });
            }}
            options={
              <>
                <option value="">SELECT</option>
                {(addData?.action === "product"
                  ? stock_report_list?.productlist
                  : stock_report_list?.godownlist
                )
                  ?.filter(
                    (obj, index, self) =>
                      index === self.findIndex((t) => t?.ID === obj?.ID)
                  )
                  ?.map((v, i) => (
                    <option value={v?.ID} key={i}>
                      {addData?.action === "product"
                        ? `${v?.CAT_NAME} - ${v?.CAT_DESC}`
                        : v?.UNIT_NAME}
                    </option>
                  ))}
              </>
            }
          />
        </div>

        {/* Conditional Godown Dropdown */}
        {addData?.show_godown && (
          <div style={{ width: "180px" }}>
            <Dropdown
              label="SELECT GODOWN"
              value={addData?.godown_id}
              onChange={(e) => {
                setAddData({
                  ...addData,
                  godown_id: e.target.value,
                });
              }}
              options={
                <>
                  <option value="">SELECT</option>
                  {stock_report_list?.godownlist
                    ?.filter(
                      (obj, index, self) =>
                        index === self.findIndex((t) => t?.ID === obj?.ID)
                    )
                    ?.map((v, i) => (
                      <option value={v?.ID} key={i}>
                        {v?.UNIT_NAME}
                      </option>
                    ))}
                </>
              }
            />
          </div>
        )}

        {/* Search Button */}
        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <Button
            title="SEARCH"
            onClick={async () => {
              await setShowData(false);
              await setPageNo(1);
              get_list(addData, "main");
            }}
          />
        </div>
      </div>

      {/* --- Data Result Section --- */}
      {showData ? (
        stock_report_item_list?.length > 0 ? (
          <>
            <div className="SFromDate">
              <span style={{ fontSize: "11px" }}>FROM DATE :</span>
              <p className="FDATE">
                {moment(addDataPre?.from_date).format("DD/MM/YY")}
              </p>
              <span style={{ fontSize: "11px" }}>TO DATE :</span>
              <p className="FDATE">
                {moment(addDataPre?.to_date).format("DD/MM/YY")}
              </p>
              <span style={{ fontSize: "11px" }}>
                {addDataPre?.action === "godown" ? "GODOWN" : "PRODUCT"}{" "}
                SELECTED:
              </span>
              <h6 className="PDS">{addDataPre?.custProdDetails}</h6>
            </div>

            <Pagination3
              count={0}
              search={false}
              download={true}
              PDFDown={() => get_list(addDataPre, "pdf")}
              excelDown={() => get_list(addDataPre, "excel")}
              top={true}
              totalCount={totalCount}
              SerchInput={serchInput}
              setSearchInput={setSerchInput}
              pageNo={pageNo}
              setPageNo={setPageNo}
              entries={entries}
              setEntries={setEntries}
            >
              {stock_report_item_list.length === 0 ? (
                <NoData mt={30} />
              ) : (
                <>
                  {/* Product View Table */}
                  {addDataPre?.action === "product" &&
                    (addDataPre?.godown_id || !addDataPre?.show_godown) && (
                      <Table
                        headData={Object.values(TableHeaderProduct)}
                        body={stock_report_item_list
                          // ?.slice((pageNo - 1) * entries, pageNo * entries)
                          ?.map((v, i) => (
                            <tr key={i}>
                              {Object.keys(TableHeaderProduct).map((key) => (
                                <td key={key}>{v?.[key]}</td>
                              ))}
                            </tr>
                          ))}
                      />
                    )}

                  {/* Second Table: Product w/ Godown OR Godown View */}
                  <Table
                    headData={
                      addDataPre?.action === "product" && addDataPre?.godown_id
                        ? Object.values(ProductGodownHeader)
                        : addDataPre?.action === "product"
                        ? Object.values(OnlyProductHeader)
                        : Object.values(godownHeader)
                    }
                    body={(addDataPre?.action === "godown"
                      ? stock_report_item_list
                      : totalData
                    )
                      // ?.slice((pageNo - 1) * entries, pageNo * entries)
                      ?.map((v, i) => (
                        <tr key={i}>
                          {(addDataPre?.action === "product" &&
                          addDataPre?.godown_id
                            ? Object.keys(ProductGodownHeader)
                            : addDataPre?.action === "product"
                            ? Object.keys(OnlyProductHeader)
                            : Object.keys(godownHeader)
                          ).map((key) => (
                            <td key={key}>{v?.[key]}</td>
                          ))}
                        </tr>
                      ))}
                  />
                </>
              )}
            </Pagination3>
          </>
        ) : (
          <NoData title="NO RECORDS FOUND" color="red" mt={30} />
        )
      ) : null}
    </div>
  );
};

export default StockReport;

// const export_pdf = (addData, data, total) => {
//   exportPDF({
//     table_data: table_data(data, total),
//     table_headers: ["S.No.", ...table_header_1],
//     fileName: `${firm_name} - STOCK REPORTS -- FROM DATE : ${moment(
//       addData?.from_date
//     ).format("DD/MM/YY")} & TO DATE : ${moment(addData?.to_date).format(
//       "DD/MM/YY"
//     )}   :: ${addData?.action == "godown" ? "GODOWN" : "PRODUCT"} : : ${
//       addData?.custProdDetails
//     }`,
//     tableName: `${firm_name} - STOCK REPORTS -- FROM DATE : ${moment(
//       addData?.from_date
//     ).format("DD/MM/YY")} & TO DATE : ${moment(addData?.to_date).format(
//       "DD/MM/YY"
//     )}   :: ${addData?.action == "godown" ? "GODOWN" : "PRODUCT"} : : ${
//       addData?.custProdDetails
//     }`,
//     table2: true,
//     table_headers_2: table_header,
//     table_data_2: table_data_2(totalData, total),
//   });
// };

// const export_excel = (addData, data, total) => {
//   downloadExcel1(
//     table_data(data, total),
//     ["S.No.", ...table_header_1],
//     `${firm_name} - STOCK REPORTS -- FROM DATE : ${moment(
//       addData?.from_date
//     ).format("DD/MM/YY")} & TO DATE : ${moment(addData?.to_date).format(
//       "DD/MM/YY"
//     )}   :: ${addData?.action == "godown" ? "GODOWN" : "PRODUCT"} : : ${
//       addData?.custProdDetails
//     }`,
//     table_data_2(totalData, total),
//     table_header
//   );
// };

// naveen patidar is my friend
